<template>
  <div id="app">
    <b-container>
      <Navbar />
      <router-view/>
      <Footer />
    </b-container>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Component from 'vue-class-component';
import Vue from 'vue';
import Vuex from 'vuex';
import VueAnalytics from 'vue-analytics';
import VueCarousel from 'vue-carousel';
import { integer } from 'vee-validate';

Vue.use(VueCarousel);
Vue.use(Vuex);

export default {
  components: {
    Navbar,
    Footer,
  },
};
</script>


<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700');
  #app {
    font-family: 'IBM Plex Mono', monospace;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  #logo{
    height: 20px;
  }
  #footer{
    font-size:10px;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .navbar{
    margin-bottom: 30px;
    padding:10px 0;
  }
  .blm{
    background-color: black;
    color: yellow;
    font-weight: bold;
    font-size:12px;
    display: inline-block;
    padding: .5rem;
  }
  .navbar-toggler{
    border: none;
  }
  .navbar-light .navbar-toggler{
    padding: 0px;
  }
  .navbar-collapse.show{
    background-color: #171a1d;
    a.nav-link,a.nav-link:active, a.nav-link:hover {
      color: white;
      padding: 10px;
    }
  }

  h1{
    font-size: 1.5rem;
    font-weight: lighter;
    display: inline-block;
  }
  p{
    font-weight: 500;
  }
</style>
